import { JsonObject } from 'json2typescript';
import { profileAnalisysInterface } from '../interfaces/profile-analysis.interface';

@JsonObject('ProfileAnalysis')
export class ProfileAnalysisModel implements profileAnalisysInterface {
  AssetClassDistribution?: AssetClassDistribution[];
  AssetTypeDistribution?: AssetTypeDistribution[];
  CumulativePerformance?: CumulativePerformance;
  Currency?: string;
  CurrencyDistribution?: CurrencyDistribution[];
  Fees?: Fees;
  MinimunInvestment?: number;
  PerformanceIndex?: PerformanceIndex;
  Positions?: Position[];
  RegionDistribution?: RegionDistribution[];
  SectorDistribution?: SectorDistribution[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class AssetClassDistribution {
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class AssetTypeDistribution {
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class CumulativePerformance {
  Code?: string;
  Id?: string;
  Name?: string;
  Performance1M?: number;
  Performance1W?: number;
  Performance1Y?: number;
  Performance3M?: number;
  Performance3Y?: number;
  Performance5Y?: number;
  PerformanceDateToDate?: number;
  PerformanceStartDate?: number;
  PerformanceYTD?: number;
  ProfileName?: string;
  Type?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class CurrencyDistribution {
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class Fees {
  CustodyFees?: number;
  CustodyId?: string;
  CustodyName?: string;
  ImplicitFees?: number;
  OtherFees?: number;
  ServiceFees?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class PerformanceIndex {
  Dates?: string[];
  Performance?: number[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class Position {
  AssetClass?: string;
  AssetClassId?: string;
  AssetId?: string;
  AsseType?: string;
  AsseTypeId?: string;
  Currency?: string;
  EncryptedCode?: string;
  ISIN?: string;
  LastDate?: string;
  LastPrice?: number;
  Name?: string;
  PriceCotation?: string;
  ProductCode?: string;
  Valuation?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class RegionDistribution {
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class SectorDistribution {
  Code?: string;
  Name?: string;
  Value?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
